// Presentation guards; endpoint functions and server field names remain unchanged.
export const textValue = value => typeof value === 'string' ? value : typeof value === 'number' ? String(value) : '';
export const fields = ['title', 'description', 'image'];
export const settingsFields = ['email', 'phone', 'facebook', 'twitter', 'linkedin', 'instagram', 'whatsapp'];
export function resource() { return { status: 'loading', data: null, message: '' }; }
const record = value => value && typeof value === 'object' && !Array.isArray(value);
export function decodeResponse(response, kind = 'page') {
  const body = response?.data;
  if (!record(body) || !(body.status === true || body.status === 1)) {
    const error = new Error(textValue(body?.message));
    error.name = 'PublicContentError';
    throw error;
  }
  const data = body.data;
  if (data == null) return null;
  const allowed = kind === 'settings' ? settingsFields : kind === 'sponsors' ? ['image'] : [...fields, 'created_at'];
  const normalize = value => {
    if (!record(value)) throw new Error('');
    return Object.fromEntries(allowed.map(key => [key, textValue(value[key])]));
  };
  const hasContent = value => allowed.some(key => key !== 'created_at' && value[key]?.trim());
  if (kind === 'list' || kind === 'sponsors') {
    if (!Array.isArray(data)) throw new Error('');
    const rows = data.map(normalize).filter(hasContent);
    return rows.length ? rows : null;
  }
  const value = normalize(data);
  return hasContent(value) ? value : null;
}
export async function loadResource(state, request, kind = 'page') {
  if (state.pending) return;
  state.pending = true;
  state.status = 'loading';
  state.message = '';
  state.data = null;
  try {
    state.data = decodeResponse(await request(), kind);
    state.status = state.data ? 'ready' : 'empty';
  } catch (error) {
    state.status = 'error';
    state.message = textValue(error?.response?.data?.message) || (error?.name === 'PublicContentError' ? error.message : '');
  } finally { state.pending = false; }
}
export function safeWebUrl(value) {
  if (typeof value !== 'string' || !value.trim()) return '';
  try {
    const url = new URL(value, 'https://leader.invalid');
    return ['http:', 'https:'].includes(url.protocol) ? value : '';
  } catch { return ''; }
}

/** CMS placeholders that should not replace localized product copy. */
const GENERIC_CMS = /^(الرئيسية|وصف الرئيسية|home|main|home description|main description)$/i;
export function isGenericCmsCopy(value) {
  const text = textValue(value).replace(/\s+/g, ' ').trim();
  return !text || GENERIC_CMS.test(text);
}

/** Logo files used as CMS “hero” images — prefer local logistics photography instead. */
export function isLogoCmsImage(value) {
  const text = textValue(value).toLowerCase();
  if (!text) return true;
  return /logo[_-]?\d*\.(png|jpe?g|webp|svg)(\?|$)/i.test(text) || /\/logo\./i.test(text);
}
